/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Agent_Development_CatInputs */

const en_svc_ai_agent_development_cat = /** @type {(inputs: Svc_Ai_Agent_Development_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#AGENTS`)
};

const ar_svc_ai_agent_development_cat = /** @type {(inputs: Svc_Ai_Agent_Development_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#وكلاء`)
};

const bn_svc_ai_agent_development_cat = /** @type {(inputs: Svc_Ai_Agent_Development_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#AGENTS`)
};

const de_svc_ai_agent_development_cat = /** @type {(inputs: Svc_Ai_Agent_Development_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#AGENTS`)
};

const es_svc_ai_agent_development_cat = /** @type {(inputs: Svc_Ai_Agent_Development_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#AGENTS`)
};

const fr_svc_ai_agent_development_cat = /** @type {(inputs: Svc_Ai_Agent_Development_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#AGENTS`)
};

const pt_svc_ai_agent_development_cat = /** @type {(inputs: Svc_Ai_Agent_Development_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#AGENTS`)
};

const zh_svc_ai_agent_development_cat = /** @type {(inputs: Svc_Ai_Agent_Development_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#AGENTS`)
};

const tr_svc_ai_agent_development_cat = /** @type {(inputs: Svc_Ai_Agent_Development_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#AGENTS`)
};

const ru_svc_ai_agent_development_cat = /** @type {(inputs: Svc_Ai_Agent_Development_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#AGENTS`)
};

const pl_svc_ai_agent_development_cat = /** @type {(inputs: Svc_Ai_Agent_Development_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#AGENTS`)
};

/**
* | output |
* | --- |
* | "#AGENTS" |
*
* @param {Svc_Ai_Agent_Development_CatInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_agent_development_cat = /** @type {((inputs?: Svc_Ai_Agent_Development_CatInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Agent_Development_CatInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_agent_development_cat(inputs)
	if (locale === "bn") return bn_svc_ai_agent_development_cat(inputs)
	if (locale === "de") return de_svc_ai_agent_development_cat(inputs)
	if (locale === "es") return es_svc_ai_agent_development_cat(inputs)
	if (locale === "fr") return fr_svc_ai_agent_development_cat(inputs)
	if (locale === "pt") return pt_svc_ai_agent_development_cat(inputs)
	if (locale === "zh") return zh_svc_ai_agent_development_cat(inputs)
	if (locale === "tr") return tr_svc_ai_agent_development_cat(inputs)
	if (locale === "ru") return ru_svc_ai_agent_development_cat(inputs)
	if (locale === "pl") return pl_svc_ai_agent_development_cat(inputs)
	return en_svc_ai_agent_development_cat(inputs)
});
export { svc_ai_agent_development_cat as "svc_ai-agent-development_cat" }